
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import StudentHeader from "./Component/StudentHeader";
import Select from 'react-select';
import { PiStudent } from "react-icons/pi";
import { TbPasswordUser } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import { IoMaleFemale } from "react-icons/io5";
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
class StudentReports extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getSchoolList(paginationData));
    // this.props.dispatch(assessmentActions.getStudentList(paginationData));
  }


  render() {

    let { assessment } = this.props
    // let { view } = this.state;
    let { getSchoolListData, getStudentListData } = assessment;

    let fieldList = [
      {
        "label": "Student Name:",
        "value": "name",
        "type": "text"
      },
      {
        "label": "Student Email:",
        "value": "email",
        "type": "email"
      },
      {
        "label": "Student Ph No:",
        "value": "mobile",
        "type": "mobile"
      }
    ]
    let colourOptions = [
      {
        "label": "Counselor:",
        "value": "Counselor"
      },
      {
        "label": "Role",
        "value": "Role"
      }
    ]


    return (
      <>
        <StudentHeader />

        <div className="flex items-start justify-center bg-[#F9FAFB]">
          <section className="px-4 xl:w-11/12 mx-auto w-full xl:px-0">

            <div className="w-full flex-1 space-y-4">

              <div className="flex flex-col md:flex-row p-6 space-x-0 md:space-x-10">
                <div className="md:w-1/3 bg-card space-y-6">
                  <div className="bg-white rounded-md pb-10 flex flex-wrap items-center justify-center">
                    <div className="h-32 overflow-hidden rounded-md">
                      <img className="w-full" src="/assessment_images/School/profile-bg.webp" alt="profile-bg" />
                    </div>
                    <div className="flex justify-center px-5 -mt-12">
                      <img className="h-32 w-32 bg-white p-2 rounded-full" src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80" alt="" />
                    </div>
                    <div className=" ">
                      <div className="text-center px-14">
                        <h2 className="text-gray-800 text-3xl font-bold">Mohit Dhiman</h2>
                        <p className="text-gray-400 hover:text-blue-500" href="https://www.instagram.com/immohitdhiman/" target="BLANK()">@immohitdhiman</p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-md pb-10 p-4">
                    <p className="text-[#212121] text-lg font-medium">Status</p>
                    <div className="flex flex-row items-center gap-6 py-4 border-b">
                      <div className="flex flex-shrink-0 justify-center items-center border border-[#2196F3]/10 lg:w-16 w-14 lg:h-16 h-14 bg-[#2196F3]/10 rounded-md text-[#2196F3]">
                        <img src="/assessment_images/School/total-school.svg" alt="total-school.svg" className="w-10 h-10" />
                      </div>
                      <div className=" mt-1 text-[#212121] flex-1">
                        <p className="text-base">Total Schools</p>
                        <h2 className="text-xl font-semibold text-[#212121]">3,250</h2>
                      </div>
                    </div>
                    <div className="flex flex-row items-center gap-6 py-4 border-b">
                      <div className="flex flex-shrink-0 justify-center items-center border border-[#2196F3]/10 lg:w-16 w-14 lg:h-16 h-14 bg-[#2196F3]/10 rounded-md text-[#2196F3]">
                        <PiStudent className="w-10 h-10" />
                      </div>
                      <div className=" mt-1 text-[#212121] flex-1">
                        <p className="text-base ">Total Students</p>
                        <h2 className="text-xl font-semibold text-[#212121]">6,250</h2>
                      </div>
                    </div>
                    <div className="flex flex-row items-center gap-6 py-4 border-b">
                      <div className="flex flex-shrink-0 justify-center items-center border border-[#2196F3]/10 lg:w-16 w-14 lg:h-16 h-14 bg-[#2196F3]/10 rounded-md text-[#2196F3]">
                        <TbPasswordUser className="w-10 h-10" />
                      </div>
                      <div className=" mt-1 text-[#212121] flex-1">
                        <p className="text-base ">Total Assessment Codes</p>
                        <h2 className="text-xl font-semibold text-[#212121]">8,125</h2>
                      </div>
                    </div>
                  </div>
                </div>

                <section className="md:w-2/3 md:mt-0 bg-white rounded-md p-6">
                  <div className="space-y-3">
                    <h2 className="text-[#212121] text-lg font-medium bg-gray-100 p-2 rounded-md">Gereral Information</h2>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
                      {fieldList.map((ele) =>
                        <div className="text-sm space-y-1">
                          <label>{ele.label}</label>
                          <div className="text-sm">
                            <input type="text" value="" placeholder={"Enter " + ele.label + "..."} className="px-2 py-2.5    w-full border border-gray-300 outline-none rounded-md" />
                          </div>
                        </div>
                      )}
                      <div className="text-sm space-y-1">
                        <label>Role:</label>
                        <Select className="text-[#212121] text-sm font-medium"
                          options={colourOptions}
                          defaultValue={colourOptions[0]}
                          placeholder="Select Student"
                        // onChange={this.onSelectSchool}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="space-y-3 mt-6">
                    <h2 className="text-[#212121] text-lg font-medium bg-gray-100 p-2 rounded-md">Address</h2>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
                      {fieldList.map((ele) =>
                        <div className="text-sm space-y-1">
                          <label>{ele.label}</label>
                          <div className="text-sm">
                            <input type="text" value="" placeholder={"Enter " + ele.label + "..."} className="px-2 py-2.5    w-full border border-gray-300 outline-none rounded-md" />
                          </div>
                        </div>
                      )}
                      <div className="text-sm space-y-1">
                        <label>Role:</label>
                        <Select className="text-[#212121] text-sm font-medium"
                          options={colourOptions}
                          defaultValue={colourOptions[0]}
                          placeholder="Select Student"
                        // onChange={this.onSelectSchool}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="space-y-3 mt-6">
                    <h2 className="text-[#212121] text-lg font-medium bg-gray-100 p-2 rounded-md">Demographic</h2>
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
                      <div className="text-sm space-y-1">
                        <label>Gender:</label>
                        <div className="flex space-x-4">
                          <div className="flex space-x-2 border border-[#2196F3] text-[#2196F3] rounded-md px-2 py-1">
                            <PiGenderMaleBold className="h-5 w-5" />
                            <p>Male</p>
                          </div>
                          <div className="flex space-x-2 border border-[#212121]/70 rounded-md px-2 py-1 text-[#212121]/70">
                            <PiGenderFemaleBold className="h-5 w-5" />
                            <p>Female</p>
                          </div>
                          <div className="flex space-x-2 border border-[#212121]/70 rounded-md px-2 py-1 text-[#212121]/70">
                            <IoMaleFemale className="h-5 w-5" />
                            <p>Other</p>
                          </div>
                        </div>
                      </div>
                      <div className="text-sm space-y-1">
                        <label>Role:</label>
                        <div className="text-[#212121] text-sm font-medium">
                          <DatePicker block />
                        </div>
                      </div>
                    </div>
                  </div>
                </section >
              </div >

            </div >

          </section >
        </div >

      </>
    );
  }
}

StudentReports.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(StudentReports);
